import script from "./PageReportsReadiness.vue?vue&type=script&setup=true&lang=js"
export * from "./PageReportsReadiness.vue?vue&type=script&setup=true&lang=js"

import "./PageReportsReadiness.vue?vue&type=style&index=0&id=8b3f76c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8b3f76c2"]])

export default __exports__